import React from "react";
import { Box, Flex, Image, Stack, Text } from "@chakra-ui/core";
import { Header } from "../../../components/Dashboard/Header";
import { FiHome } from "react-icons/fi";

import { InvestorDashboardNavigator } from "../../../navigator/InvestorDashboardNavigator";
import { SideNav } from "../../../components/Dashboard/SideNav";
import useAuth from "../../../context/AuthContext";

const InvestorDashboard = () => {
  const [show, setShow] = React.useState(false);
  const {
    state: { user },
  } = useAuth();

  const handleToggle = () => setShow(!show);

  return (
    <Flex direction='column'>
      <Header title='Dashboard' icon={FiHome} toggle={handleToggle} />
      <Flex mt='55px' w='100%' h='120vh' overflow='hidden' position='fixed'>
        <Box
          flex={["1"]}
          bg='#069638'
          h='100vh'
          display={{ base: show ? "block" : "none", md: "flex" }}
          overflowY='hidden'
          position={["fixed", "relative"]}
          zIndex='100'
        >
          <SideNav />
        </Box>
        <Box
          flex='5'
          bg='#ffffff'
          h='100vh'
          d='flex'
          flexDirection='column'
          overflowY='scroll'
          position='relative'
          zIndex='50'
          mb='60'
          pb='60'
        >
          {user.isActive ? (
            <InvestorDashboardNavigator toggle={() => setShow(false)} />
          ) : (
            <Stack
              w='100%'
              mx='auto'
              justifySelf='center'
              alignSelf='center'
              justify='center'
              align='center'
              h='90vh'
            >
              <Box w='100px' alignSelf='center'>
                <Image
                  src={require("../../../assets/icons/icon-user.png")}
                  alt='Account Locked'
                  w='100%'
                />
              </Box>

              <Text
                textAlign='center'
                fontSize={["xl", "2xl"]}
                fontWeight='700'
                mb='4'
              >
                Your account has been deactivated
              </Text>
            </Stack>
          )}
        </Box>
      </Flex>
    </Flex>
  );
};

export default InvestorDashboard;
